import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getAuthHeaders from '@anm/helpers/getAuthHeaders';
import SHA256 from 'crypto-js/sha256';
import playerConfig from '../../config';

var getSourceUrl = function getSourceUrl(_ref) {
  var hostId = _ref.hostId,
      env = _ref.env,
      source = _ref.source,
      query = _ref.query;
  var queryParam = typeof query !== 'undefined' ? "?hash=".concat(SHA256(query)) : '';

  switch (source) {
    case 'api':
      return "".concat(playerConfig(env).apiUrl, "/host/").concat(hostId, "/manifest");

    case 'cdn':
      return "".concat(playerConfig(env).cdnUrl, "/").concat(hostId, "/manifest.json").concat(queryParam);
  }
};

var getManifest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var env, hostId, query, _ref3$source, source, manifestSource, getHeaders;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            env = _ref3.env, hostId = _ref3.hostId, query = _ref3.query, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? 'cdn' : _ref3$source;
            manifestSource = getSourceUrl({
              env: env,
              query: query,
              hostId: hostId,
              source: source
            });

            getHeaders = function getHeaders() {
              return source !== 'cdn' ? getAuthHeaders() : {};
            };

            return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                var result, res;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return fetch(manifestSource, getHeaders());

                      case 2:
                        result = _context.sent;
                        _context.next = 5;
                        return result.json();

                      case 5:
                        res = _context.sent;
                        res.id || res.status ? resolve(_objectSpread(_objectSpread({}, res), {}, {
                          main: res.main || []
                        })) : reject(res);

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2, _x3) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getManifest(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export default getManifest;